import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Pages/Home/Home';
import Referral from './Pages/Referral/Referral';
import Market from './Pages/Market/Market';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/m" element={<Market />} />
        <Route path="/ref" element={<Referral />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </Router>
  );
}

export default App;

